/** Gzip UTF-8 bodies when `CompressionStream` exists (Chromium / Node 18+). */

export function canGzipHttpBody(): boolean {
  return (
    typeof CompressionStream !== 'undefined' &&
    typeof Blob !== 'undefined' &&
    typeof Blob.prototype.stream === 'function'
  );
}

/** Returns gzip bytes + encoding header, or plain text when streams unavailable. */
export async function encodeGzipHttpBody(
  utf8: string,
): Promise<{ body: BodyInit; contentEncoding?: 'gzip' }> {
  if (!canGzipHttpBody()) return { body: utf8 };
  const body = await new Response(
    new Blob([utf8]).stream().pipeThrough(new CompressionStream('gzip')),
  ).arrayBuffer();
  return { body, contentEncoding: 'gzip' };
}
